import { HttpRequestError } from '../../../../core/infrastructure/adapters/FetchHttpClientAdapter';
import { HttpClientPort } from '../../../../core/domain/ports/HttpClientPort';
import { AnimaliaListItemApiResponse, AnimaliaListingMapper } from '../../application/mappers/AnimaliaListingMapper';
import { AnimaliaListItem } from '../../domain/entities/AnimaliaListItem';
import { AnimaliaDetailRepositoryPort } from '../../domain/ports/AnimaliaDetailRepositoryPort';

export class AnimaliaDetailApiRepositoryAdapter implements AnimaliaDetailRepositoryPort {
  constructor(private readonly httpClient: HttpClientPort) {}

  async fetchBySlug(slug: string): Promise<AnimaliaListItem | null> {
    try {
      const response = await this.httpClient.get<AnimaliaListItemApiResponse>(
        `/api/v1/${encodeURIComponent(slug)}`,
      );

      return AnimaliaListingMapper.fromApiResponse(response);
    } catch (error: unknown) {
      if (error instanceof HttpRequestError && error.status === 404) {
        return null;
      }

      throw error;
    }
  }
}
